import i18n from "i18next";

// @ts-expect-error TS2307: Cannot find module './cs/common.yml' or its corresponding type declarations.
import csCommonLocales from "./cs/common.yml";

export const cs = {
	common: csCommonLocales,
};

i18n.init({
	fallbackLng: "cs",
	ns: ["common"],
	defaultNS: "common",
	resources: {cs},
	returnObjects: true,
	interpolation: {
		escapeValue: false,
	},
});

export default i18n;
